import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import "./Video.scss";
import { Row, Col } from "reactstrap";
import Counter from "../../Tool/Counter/Counter";
import cloneDeep from "lodash.clonedeep";
import * as UTILS from "../../../utils/Utils";
import Popup from "../../Modal/Popup";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import ResizeControls from "../../../assets/images/resizeControls.svg";
import RangeInputSlider from "../../Tool/RangeSlider";
import videoSVG from "../../../assets/images/videoTool.svg";
import noImage from "../../../assets/images/noImage.png";
import { filter } from "lodash";
import { noop } from "lodash";
class VideoModal extends Component {
  constructor(props) {
    super(props);
    this.widthInputVideo = this.props.widthInputVideo;
    this.state = {
      ID: this.props.ID,
      maxWidthRange: null,
    };
  }

  componentDidMount = () => {

    this.setState({
      maxWidthRange: this.props.widthInputVideo.current.clientWidth,
    });
  };
  videoControl = (e) => {
    const layout = JSON.parse(JSON.stringify(this.props.layout));

    this.props.layoutArray(
      this.props.layoutTitle,
      layout.map((item) => {
        if (item.id === this.state.ID) {
          item.control = e.target.checked;
          return item;
        }
        if (item.data == "Row") {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((colItem) => {
              if (colItem.id == this.state.ID) {
                colItem.control = e.target.checked;
                return colItem;
              } else if (colItem.data == "Row") {
                Object.keys(colItem.columns).map((colNested, colIndex) => {
                  return colItem.columns[colNested].map((colItemNested) => {
                    if (colItemNested.id == this.state.ID) {
                      colItemNested.control = e.target.checked;
                      return colItemNested;
                    }
                    return colItemNested;
                  });
                });
              }
              return colItem;
            });
          });
        }
        return item;
      })
    );
  };
  videoAutoplay = (e) => {
    const layout = JSON.parse(JSON.stringify(this.props.layout));

    this.props.layoutArray(
      this.props.layoutTitle,
      layout.map((item) => {
        if (item.id === this.state.ID) {
          item.autoplay = e.target.checked;
          return item;
        }
        if (item.data == "Row" || item.data == "Accordion") {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((colItem) => {
              if (colItem.id == this.state.ID) {
                colItem.autoplay = e.target.checked;
                return colItem;
              } else if (colItem.data == "Row" || colItem.data == "Accordion") {
                Object.keys(colItem.columns).map((colNested, colIndex) => {
                  return colItem.columns[colNested].map((colItemNested) => {
                    if (colItemNested.id == this.state.ID) {
                      colItemNested.autoplay = e.target.checked;
                      return colItemNested;
                    }
                    return colItemNested;
                  });
                });
              }
              return colItem;
            });
          });
        }
        return item;
      })
    );
  };
  widthToggle = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const unitType =
      this.props.videoWidthUnit == "%" ? this.props.videoWidthUnit : "px";

    var selectedValue;

    if (e.target.checked == true) {
      if (unitType == "px") {
        selectedValue = this.props.maxWidthRange;
      } else {
        selectedValue = 100;
      }
    } else {
      if (unitType == "px") {
        selectedValue = this.props.maxWidthRange / 2;
      } else {
        selectedValue = 50;
      }
    }

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  videoModal = (e) => {
    const layout = cloneDeep(this.props.layout);

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.state.ID,
      (item) => {
        item.modal = e.target.checked;
      },
      (colItem) => {
        colItem.modal = e.target.checked;
      },
      (colItemNested) => {
        colItemNested.modal = e.target.checked;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  videoChapters = (e) => {
    const layoutClone = JSON.parse(JSON.stringify(this.props.layout));
    const newLayout = UTILS.UpdateLayout(
      layoutClone,
      this.state.ID,
      (item) => {
        item.chapters = e.target.checked;
        item.modal = e.target.checked == true ? true : false;
      },
      (colItem) => {
        colItem.chapters = e.target.checked;
        colItem.modal = e.target.checked == true ? true : false;
      },
      (colItemNested) => {
        colItemNested.chapters = e.target.checked;
        colItemNested.modal = e.target.checked == true ? true : false;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.state.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.state.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.state.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  unitValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  rangeWidthSlider = (width) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      width !== "" && width !== "0" && width !== "00"
        ? width.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style.maxWidth = selectedValue;
      },
      (colItem) => {
        colItem.style.maxWidth = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style.maxWidth = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  unitWidthValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
        item.style.maxWidth = e.target.value == "%" ? "100" : "400";
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
        colItem.style.maxWidth = e.target.value == "%" ? "100" : "400";
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
        colItemNested.style.maxWidth = e.target.value == "%" ? "100" : "400";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  addVideoLabel = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(this.props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.label = selectedValue;
      },
      (colItem) => {
        colItem.label = selectedValue;
      },
      (colItemNested) => {
        colItemNested.label = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  render() {
console.log(this.props.videoTitle)
    return (
      <Popup
        width="700"
        header="Video Settings"
        parentID="imageSetting"
        closePopup={this.props.hideVideoSetting}
        close={this.props.hideVideoSetting}
      >
        <div className="modalScrollContainerSecondary">
          <div className="modalContentWrapper">
            {" "}
            <label>
              Video Label <small> (For Meta Data and Aria Labels)</small>
            </label>
            <input
              onChange={this.addVideoLabel}
              defaultValue={this.props.label}
              placeholder="Add Video Label"
              className="imageLabelInput"
              type="text"
            />
            {this.props?.videoTitle && (
              <div style={{ marginTop: "15px", marginBottom: "10px" }}>
                <label style={{ fontWeight: "600", color: "#333" }}>
                  Video Title
                </label>
                <div style={{ 
                  padding: "10px", 
                  backgroundColor: "#f5f5f5", 
                  borderRadius: "4px",
                  color: "#666",
                  fontSize: "14px"
                }}>
                  {this.props.videoTitle}
                </div>
              </div>
            )}
            <Row className="fieldsWrapper">
              <Col sm="12">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {this.props.if_src ? (
                    <img
                      onError={(e) => {
                        e.target.src = noImage;
                      }}
                      style={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        width: "300px",
                        height: "auto",
                        boxShadow: "0 0 10px 0px #0078ff",
                        border: "solid 1px #0078ff",
                      }}
                      src={
                        this.props.if_src
                          ? this.props.if_src
                          : this.props.vimeoTHUMB
                          ? this.props.vimeoTHUMB
                          : this.props.youtubeTHUMB
                          ? this.props.youtubeTHUMB
                          : ""
                      }
                    ></img>
                  ) : (
                    <img
                      onError={(e) => {
                        e.target.src = noImage;
                      }}
                      style={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        maxWidth: "300px",
                        maxHeight: "auto",
                        boxShadow: "0 0 10px 0px #0078ff",
                        border: "solid 1px #0078ff",
                      }}
                      src={
                        this.props.vimeoTHUMB
                          ? this.props.vimeoTHUMB
                          : this.props.youtubeTHUMB
                          ? this.props.youtubeTHUMB
                          : ""
                      }
                    ></img>
                  )}
                  <button
                    onClick={() => {
                      this.props.changeVideo();
                      this.props.hideVideoSetting();
                    }}
                    className="select-various-content-button"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20.5"
                      height="14"
                      viewBox="0 0 26.5 19"
                    >
                      <g id="image" transform="translate(0.75 0.751)">
                        <path
                          id="video"
                          d="M19,13.25,27,7.5V20l-8-5.625V13.25ZM4.5,5H15.75a2.5,2.5,0,0,1,2.5,2.5V20a2.5,2.5,0,0,1-2.5,2.5H4.5A2.5,2.5,0,0,1,2,20V7.5A2.507,2.507,0,0,1,4.5,5Z"
                          transform="translate(-2 -5)"
                          fill="none"
                          stroke="#708fab"
                          strokeLinecap="square"
                          strokeWidth="1.5"
                        />
                      </g>
                    </svg>

                    {this.props.if_src ? "Change Video" : "Add Video"}
                  </button>
                </div>
                {this.props.children}
              </Col>
            </Row>
          </div>

          <div
            style={{ marginTop: "30px", marginBottom: "20px" }}
            className="padding-section"
          >
            <div className="heading">Width</div>
          </div>
          <div className="modalContentWrapper">
            <Row>
              <Col sm="2" className="videoWidth">
                <label>
                  Width <small>100%</small>
                </label>
                <input
                  key={Math.random()}
                  className="checkMark"
                  type="checkbox"
                  id="widthPercentage"
                  name="width"
                  value="percentage"
                  onChange={(e) => {
                    this.widthToggle(e, "maxWidth");
                  }}
                  checked={
                    this.props.videoWidthUnit == "%"
                      ? this.props.VideoWidth == 100
                      : this.props.VideoWidth == this.props.maxWidthRange
                  }
                />
                <label htmlFor="widthPercentage"></label>
              </Col>
              <Col sm="10" className="videoWidth">
                {" "}
                <div className=" widthSlideRange">
                  {this.props.VideoWidth != "" && (
                    <Fragment>
                      <label>
                        Video Width <small>(Set range for video width)</small>
                        <div style={{ width: "100px", float: "right" }}>
                          <UnitSelector
                            value={
                              this.props.videoWidthUnit
                                ? this.props.videoWidthUnit
                                : "px"
                            }
                            onChange={(e) => {
                              this.unitWidthValueChange(e, "videoWidthUnit");
                            }}
                          />
                        </div>
                      </label>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{ width: "100%" }}
                          className="rangeWidthSlider"
                        >
                          <RangeInputSlider
                            onChangeHandler={(widthVal) => {
                              this.rangeWidthSlider(widthVal);
                            }}
                            widthValue={this.props.VideoWidth}
                            maxWidthRange={
                              this.props.videoWidthUnit == "%"
                                ? 100
                                : this.state.maxWidthRange
                            }
                          />
                        </div>
                        <span className="widthRangeLabel">
                          <input
                            onChange={(e) => {
                              UTILS.ValidateIfValueNumber(e.target.value) &&
                              (this.props.videoWidthUnit == "%"
                                ? e.target.value < 100
                                : e.target.value)
                                ? this.counterChange(e, "maxWidth")
                                : null;
                            }}
                            value={this.props.VideoWidth}
                            type="text"
                          />
                        </span>
                      </div>
                    </Fragment>
                  )}
                </div>
              </Col>
            </Row>
          </div>

          <div
            style={{ marginTop: "30px", marginBottom: "20px" }}
            className="padding-section"
          >
            <div className="heading">Margin</div>
          </div>
          <div className="modalContentWrapper">
            <div className="heading-row" style={{ justifyContent: "flex-end" }}>
              <UnitSelector
                value={
                  this.props.videoMarginUnit ? this.props.videoMarginUnit : "px"
                }
                onChange={(e) => {
                  this.unitValueChange(e, "videoMarginUnit");
                }}
              />
            </div>
            <div
              style={{ display: "flex", flexDirection: "row", width: "50%" }}
            >
              <div className="d-block">
                <Counter
                  label="Top"
                  small={
                    this.props.videoMarginUnit === "%" ? "percent" : "pixel"
                  }
                  minusClick={() =>
                    this.counterMinus(this.props.marginTop, "marginTop")
                  }
                  valueContent={this.props.marginTop}
                  disabled={false}
                  onChange={(e) => {
                    this.counterChange(e, "marginTop");
                  }}
                  plusClick={() =>
                    this.counterPlus(this.props.marginTop, "marginTop")
                  }
                />
              </div>
              <div className="d-block">
                <Counter
                  label="Bottom"
                  small={
                    this.props.videoMarginUnit === "%" ? "percent" : "pixel"
                  }
                  minusClick={() =>
                    this.counterMinus(this.props.marginBottom, "marginBottom")
                  }
                  valueContent={this.props.marginBottom}
                  disabled={false}
                  onChange={(e) => {
                    this.counterChange(e, "marginBottom");
                  }}
                  plusClick={() =>
                    this.counterPlus(this.props.marginBottom, "marginBottom")
                  }
                />
              </div>
            </div>
          </div>

          <div
            style={{ marginTop: "30px", marginBottom: "20px" }}
            className="padding-section"
          >
            <div className="heading">Play Settings</div>
          </div>
          <div
            style={{ display: "flex", flexDirection: "row" }}
            className="modalContentWrapper"
          >
            {" "}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                width: "100%",
              }}
            >
              <Col sm="4">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    position: "relative",
                    justifyItems: "center",
                    alignContent: "center",
                    alignItems: "center",
                    textAlignc: "center",
                  }}
                >
                  <label style={{ display: "block", textAlign: "center" }}>
                    Video Popup
                  </label>
                  <input
                    key={Math.random()}
                    onChange={this.videoModal}
                    type="checkbox"
                    id="modal"
                    disabled={this.props.chapters}
                    checked={this.props.modal && "checked"}
                  />
                </div>
              </Col>

              <Col sm="4">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    position: "relative",
                    justifyItems: "center",
                    alignContent: "center",
                    alignItems: "center",
                    textAlignc: "center",
                  }}
                >
                  <label style={{ display: "block", textAlign: "center" }}>
                    Video Autoplay{" "}
                  </label>
                  <small className="status"></small>
                  <input
                    key={Math.random()}
                    onChange={this.videoAutoplay}
                    type="checkbox"
                    id="autoplay"
                    checked={this.props.autoplay && "checked"}
                  />
                </div>
              </Col>
              {this.props.showChaptersToggle && (
                <Col sm="4">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      position: "relative",
                      justifyItems: "center",
                      alignContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <label style={{ display: "block", textAlign: "center" }}>
                      Video Chapters
                    </label>
                    <input
                      key={Math.random()}
                      onChange={this.videoChapters}
                      type="checkbox"
                      id="chapters"
                      checked={this.props.chapters && "checked"}
                    />
                  </div>
                </Col>
              )}
            </div>
          </div>
        </div>
      </Popup>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layoutTitle: state.present.layoutTitle,
    layout: state.present.layout,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(VideoModal);
